<div id="overlay-container">
  <ng-template #overlayContainer></ng-template>
</div>
